import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon } from 'lucide-react';
const chapters = [{
  title: 'La Tormenta Hormonal',
  subtitle: 'Cortisol vs. Insulina',
  page: 12
}, {
  title: 'El Protocolo 30-30-3',
  subtitle: 'El Mecanismo Único',
  page: 20
}, {
  title: 'La Despensa de la Mujer Alfa 50+',
  subtitle: 'Qué comer y qué evitar',
  page: 28
}, {
  title: 'Levantando tu Futuro',
  subtitle: 'Guía de Fuerza en Casa',
  page: 36
}, {
  title: 'El Factor Sueño y los Sofocos',
  subtitle: 'Recuperación profunda',
  page: 44
}, {
  title: 'Preguntas Frecuentes',
  subtitle: 'De la Comunidad',
  page: 50
}];
export function ContentsSection() {
  return <section className="w-full bg-sage/10 py-16 md:py-24 px-4" data-id="element-22">
      <div className="max-w-6xl mx-auto" data-id="element-23">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-serif text-4xl md:text-5xl font-bold text-terracotta text-center mb-16" data-id="element-24">
          ¿Qué Encontrarás Dentro?
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-25">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="space-y-6" data-id="element-26">
            {chapters.map((chapter, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-cream p-4 rounded-lg" data-id="element-27">
                <BookOpenIcon className="w-6 h-6 text-terracotta flex-shrink-0 mt-1" data-id="element-28" />
                <div className="flex-1" data-id="element-29">
                  <h3 className="font-serif text-xl font-semibold text-brown mb-1" data-id="element-30">
                    {chapter.title}
                  </h3>
                  <p className="text-sage" data-id="element-31">{chapter.subtitle}</p>
                </div>
                <span className="text-gold font-semibold" data-id="element-32">
                  pág. {chapter.page}
                </span>
              </motion.div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="flex justify-center" data-id="element-33">
            <img src="https://cdn.magicpatterns.com/uploads/5NHTK9Fq1vn5LGEjN9V3v8/menop.png" alt="Menopausia Activa Book" className="w-full max-w-sm shadow-2xl rounded-lg" data-id="element-34" />
          </motion.div>
        </div>
      </div>
    </section>;
}